import { CatalogueMasterConstants } from "../constants/CatalogueMasterConstants";

const initialState = {
  items: [],
  loading: false,
  error: null,

  headerUpserted: false,
  detailsUpserted: false,
};

export function catalogueMaster(state = initialState, action) {
  switch (action.type) {
    case CatalogueMasterConstants.LOADING_REQUEST:
      return {
        ...state,
        loading: action.isbool,
      };

    case CatalogueMasterConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CatalogueMasterConstants.GETALL_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.data,
      };

    case CatalogueMasterConstants.GETALL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case CatalogueMasterConstants.UPSERT_HEADER_REQUEST:
      return {
        ...state,
        loading: true,
        headerUpserted: false,
      };

    case CatalogueMasterConstants.UPSERT_HEADER_SUCCESS:
      return {
        ...state,
        loading: false,
        headerUpserted: true,
      };

    case CatalogueMasterConstants.UPSERT_HEADER_FAILURE:
      return {
        ...state,
        loading: false,
        headerUpserted: false,
        error: action.error,
      };

    case CatalogueMasterConstants.UPSERT_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        detailsUpserted: false,
      };

    case CatalogueMasterConstants.UPSERT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        detailsUpserted: true,
      };

    case CatalogueMasterConstants.UPSERT_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        detailsUpserted: false,
        error: action.error,
      };

    default:
      return state;
  }
}
